import styled, { Scale } from '@secretescapes/falcon';
import { mediaQuery } from '@utils/styles.utils';

export const Grid = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content;
  gap: ${Scale.m};

  @media ${mediaQuery.tablet}, ${mediaQuery.desktop} {
    grid-template-columns: repeat(2, 1fr);
    gap: ${Scale.l};
  }
`;
